import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import SidePanel from 'common/side-panel/side-panel';
import { Button, Row, Div } from 'ui';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import AnnouncementsFeed from './announcements-feed';
// eslint-disable-next-line max-len
import { closeAnnouncementsSidepanel } from '../../../settings/containers/announcements/announcements-actions';

const Buttons = styled(Row)`
  gap: 20px;
`;

const StyledButton = styled(Button)`
  text-transform: uppercase;
  cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
`;

const FeedbackMessage = styled(Div)`
  margin-bottom: 20px;
`;


const AnnouncementsSidepanel = ({
  intl,
  onOpenUserSnap,
  setIsSidepanelOpen,
}) => {
  const dispatch = useDispatch();
  const { isSiepanelFeedback } = useSelector(state => state.announcements);

  const close = () => {
    dispatch(closeAnnouncementsSidepanel());
    if (setIsSidepanelOpen) {
      setIsSidepanelOpen(false);
    }
  };

  return (
    <SidePanel
      width={'40%'}
      title={intl.formatMessage({ id: 'announcements.home.TITLE' })}
      onPanelClose={close}
    >
      {isSiepanelFeedback &&
        <Div>
          <FeedbackMessage>
            {intl.formatMessage({ id: 'announcements.feedback.EXPLANATION_1' })}
          </FeedbackMessage>
          <FeedbackMessage>
            {intl.formatMessage({ id: 'announcements.feedback.EXPLANATION_2' })}
          </FeedbackMessage>
        </Div>
      }
      <AnnouncementsFeed />
      <Buttons marginTop={20}>
        <StyledButton onClick={close}>
          {intl.formatMessage({ id: `common.${isSiepanelFeedback ? 'CANCEL' : 'CLOSE'}` })}
        </StyledButton>
        {isSiepanelFeedback &&
          <StyledButton
            onClick={onOpenUserSnap}
            type='secondary'
          >
            {intl.formatMessage({
              id: 'announcements.feedback.CREATE_FEEDBACK',
            })}
          </StyledButton>
        }
      </Buttons>
    </SidePanel>
  );
};

AnnouncementsSidepanel.propTypes = {
  intl: PropTypes.object,
  onOpenUserSnap: PropTypes.func,
  setIsSidepanelOpen: PropTypes.func,
};

export default injectIntl(AnnouncementsSidepanel);
